import {setIsTokenExpired} from '../components/Offline/service';
import {getRecentUpdates, refreshHomePage} from '../_shared/GWTBridge/invoke/priApi';
import {checkMail, generalGetFeedCounter} from '../_shared/GWTBridge/invoke/genPage';
import {isNetFormOnTop} from '../_shared/GWTBridge/invoke/netForm';
import OIDCWorker from '../WebWorker/webWorker';

const createWorker = (workerFunction: () => void) => {
    const code = workerFunction.toString();
    const blob = new Blob([`(${code})()`], {type: 'application/javascript'});
    return new Worker(URL.createObjectURL(blob));
};

const oidcWebWorker = createWorker(OIDCWorker);
const oidcMgr = (window as any).oidc_mgr;

const getAppUpdates = () => {
    getRecentUpdates();
    refreshHomePage();
    checkMail();
    generalGetFeedCounter();
};

const signinSilent = () => {
    if (navigator?.onLine && oidcMgr) {
        oidcMgr.getUser().then(user => {
            if (!user) return;

            setIsTokenExpired(user.expired);
            if (user.expired) {
                oidcMgr.signinSilent();
            }
        });
    }
};

let lastUpdate = new Date();

const handleVisibilityChange = (isExternalLogin?: boolean) => {
    if (document.visibilityState === 'visible') {
        if (isExternalLogin) {
            signinSilent();
        }

        if (!isNetFormOnTop()) {
            const now = new Date();
            // update only if at least 3 minutes passed since last update
            if ((now.getTime() - lastUpdate.getTime()) / 60000 > 3) {
                lastUpdate = new Date();
                getAppUpdates();
            }
        }
    }
};

const verifyExternalLogin = () => {
    const token: string = (window as any).oidc_access_token;
    if (token) {
        return token.length > 0;
    } else {
        return false;
    }
};

export const activateOIDCWorker = () => {
    const isExternalLogin = verifyExternalLogin();
    window['cacheSend'] = XMLHttpRequest.prototype.send;

    if (window.Worker) {
        window.addEventListener('visibilitychange', () => {
            handleVisibilityChange(isExternalLogin);
        });
        if (isExternalLogin) {
            oidcWebWorker.onmessage = message => {
                if (message.data.resignin) {
                    signinSilent();
                }
            };
        }
    }
};

export const clearStaleState = () => {
    const isExternalLogin = verifyExternalLogin();
    if (isExternalLogin) {
        oidcMgr?.clearStaleState();
    }
};
